export default __webpack_public_path__ + "static/retail-e.url-271aecf6ccd12450dabaf9ee39563e77.svg";